<template>
  <div class="white">
    <v-toolbar flat color="white">
      <v-toolbar-title>Prestação de contas</v-toolbar-title>
      <v-spacer></v-spacer>
      <AccountabilityDialog
        :condominiumsList="condominiumsList"
        :dialog="accountabilityDialog"
        :accountabilityDialogShowHide="accountabilityDialogShowHide"
        :accountabilityDialogEditData="accountabilityDialogEditData"
        :editItem="editItem"
      />
    </v-toolbar>
    <SearchAccountability
      :search="getAccountability"
      :condominiumsList="condominiumsList"
    />
    <v-data-table
      :headers="headers"
      :items="accountability"
      class="elevation-1 mt-4"
      style="min-height: 350px"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-icon color="success" v-if="props.item.status">check_circle</v-icon>
          <v-icon color="error" v-if="!props.item.status">block</v-icon>
        </td>
        <td class="text-xs-left">{{ props.item.name_fantasy }}</td>
        <td class="text-xs-center">{{ props.item.period }}</td>
        <td class="text-xs-left">
          {{ props.item.date_limit | moment("DD/MM/YYYY") }}
        </td>
        <td class="text-xs-center">{{ props.item.year }}</td>
        <td class="text-xs-left">
          {{ props.item.date_approve | moment("DD/MM/YYYY") }}
        </td>
        <td class="text-xs-left">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="accountabilityPermissions.edit"
                small
                class="mr-2"
                @click="editItem(props.item)"
                >edit</v-icon
              >
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="true"
                small
                class="mr-2"
                @click="editItem(props.item, 'viewForm')"
                >remove_red_eye</v-icon
              ></template
            >
            <span>Visualizar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                v-if="accountabilityPermissions.remove"
                small
                @click="confirmDelItem(props.item)"
                >delete</v-icon
              ></template
            >
            <span>Excluir</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:no-data>
        <div class="text-xs-center" style="height: 250px; padding-top: 112px">
          Não há dados
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import * as moment from 'moment'
import SearchAccountability from '@/components/accountability/SearchAccountability'
import AccountabilityDialog from '@/components/accountability/AccountabilityDialog'

export default {
  name: 'Accountability',

  components: {
    SearchAccountability,
    AccountabilityDialog
  },

  data () {
    return {
      lastSearch: {},
      accountabilityDialogEditData: {},
      accountabilityDialog: false,
      condominiumsList: [],
      accountability: [],
      headers: [
        {
          text: 'Status',
          align: 'center',
          sortable: false,
          value: 'status'
        },
        { text: 'Condomínio', sortable: false, value: 'name_fantasy' },
        {
          text: 'Periodicidade',
          align: 'center',
          sortable: false,
          value: 'period'
        },
        { text: 'Data limite', sortable: false, value: 'date_limit' },
        { text: 'Exercício', align: 'center', sortable: false, value: 'year' },
        { text: 'Data de aprovação', sortable: false, value: 'date_approve' },
        { text: 'Ações', sortable: false, value: '' }
      ]
    }
  },

  mounted () {
    this.getComdominiums()
  },

  computed: {
    accountabilityPermissions () {
      return this.$store.state.permissions.permissions.accountability
    }
  },

  methods: {
    accountabilityDialogShowHide () {
      if (this.accountabilityDialog) {
        this.accountabilityDialogEditData = {}
      }
      this.accountabilityDialog = !this.accountabilityDialog
    },

    getComdominiums () {
      let obj = {
        url: '/api/condominium',
        query: '',
        method: 'get'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        this.condominiumsList = response.data
      })
    },

    editItem (data, viewForm) {
      if (viewForm === 'viewForm') {
        data.viewForm = true
      } else {
        data.viewForm = false
      }
      this.accountabilityDialogEditData = { ...data }
      if (viewForm === 'save') {
        return
      }
      this.accountabilityDialogShowHide()
    },

    confirmDelItem (data) {
      let obj = {
        url: '/api/accountability/5',
        query: '',
        method: 'delete'
      }

      this.$store.dispatch('request/doRequest', obj).then((response) => {})
    },

    confirmDelItem (data) {
      let obj = {
        message: `Você deseja excluir a prestação de conta?`,
        title: 'Excluir prestação de conta',
        callback: (_) => {
          this.delItem(data)
        },
        type: 'warning',
        btConfirm: { name: 'Sim', show: true },
        btCancel: { name: 'Não', show: true }
      }
      this.$store.commit('confirmMessage/showConfirmMessage', obj)
    },

    delItem (data) {
      let obj = {
        url: '/api/accountability/destroy/' + data.id,
        query: '',
        method: 'delete'
      }

      this.$store.dispatch('request/doRequest', obj).then((response) => {
        if (!response) {
          return
        }
        let opts = {
          message: `Prestação de conta removida com sucesso`,
          type: 'success'
        }
        this.$store.commit('showAlert', opts)
        this.getAccountability(this.lastSearch)
      })
    },

    getAccountability (data) {
      this.lastSearch = { ...data }
      let dataSearch = {}
      
      dataSearch.params = {
        ...data
      }

      let obj = {
        url: '/api/accountability',
        query: dataSearch,
        method: 'get'
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        response.data.map((item) => {
          item.accountabilityFolders.map((date) => {
            date.analyze_sindication_send
              ? (date.analyze_sindication_send = moment(
                date.analyze_sindication_send
              ).format('DD/MM/YYYY'))
              : date.analyze_sindication_send

            date.analyze_sindication_approve
              ? (date.analyze_sindication_approve = moment(
                date.analyze_sindication_approve
              ).format('DD/MM/YYYY'))
              : date.analyze_sindication_approve

            date.analyze_manager_send
              ? (date.analyze_manager_send = moment(
                date.analyze_manager_send
              ).format('DD/MM/YYYY'))
              : date.analyze_manager_send

            date.completed_by_sindication
              ? (date.completed_by_sindication = moment(
                date.completed_by_sindication
              ).format('DD/MM/YYYY'))
              : date.completed_by_sindication
            // console.log(date);
            if (
              date.analyze_manager_send &&
              date.analyze_sindication_approve &&
              date.analyze_sindication_send &&
              date.completed_by_sindication
            ) {
              date.closedMonth = true
            }
            return date
          })
          return item
        })

        this.accountability = [...response.data]
      })
    }
  }
}
</script>
